module.exports = "/_next/static/images/share_background-5fc5057b77b1edf64a40bf693baedf00.png";